import config from '../../../config/config';

const {
    localIp, ip, port, local,
} = config.api;

export default () => `${local ? `http://${localIp}:${port}` : `https://${ip}`}`;
